import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
      title: 'Empresa Global de Factoraje de Exportación en México | Solución innovadora',
      url: WEB_URL+'/es-mx',
      name:'description',
      description:'Credlix es una empresa digital de financiación de la cadena de suministro global en India de Moglix que ofrece soluciones de capital de trabajo rápidas y sin garantías para toda la cadena de suministro.',
      keyword: 'financiación de la cadena de suministro, cadena de suministro en finanzas, empresa de financiación de la cadena de suministro', 
      imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  },
  indiaBanner:false,
  BANNER:{
    h1:'Impulsando el Comercio Global con Soluciones Inteligentes de Financiamiento',
    para:'Credlix ofrece soluciones financieras digitales y sin garantías que aceleran el crecimiento empresarial en el comercio internacional.',
    btn1:'Comercio Transfronterizo',
    btn2:'Financiamiento da Canal',
    btn3:'Financia tus importaciones desde India'
  },
  CTASection:{
    heading: '¿Listo para llevar su negocio al siguiente nivel?',
    paragraph:'Consigue financiación sin problemas para tu negocio',
    cta: 'Empezar',
    ctaLink:null
  },
  Logos:[
    {name:'Ashley',image:IMAGES.HOMEIMG.ashleyLogo},
    {name:'Home Goods',image:IMAGES.HOMEIMG.homeGoodsLogo},
    {name:'GE',image:IMAGES.HOMEIMG.geLogo},
    {name:'Ross',image:IMAGES.HOMEIMG.rossLogo},
    // {name:'SpaceX',image:IMAGES.HOMEIMG.spacexLogo},
    {name:'TJX',image:IMAGES.HOMEIMG.tjxLogo},
    {name:'Walmart',image:IMAGES.HOMEIMG.walMart},
  ],
  SolutionsSec:{
    heading:'¡Experimenta un enfoque revolucionario para el financiamiento de la cadena de suministro con Credlix!',
    paragraph:'Te ofrecemos soluciones de financiamiento personalizadas, impulsadas por tecnología de vanguardia y una amplia red de préstamos para tu empresa.',
    learnmoreCta : 'Saber más',
    solutions:[
        {heading:'Factoraje de Exportación',paragraph:'Obtén factoraje sin recurso de hasta el 90% del valor de la factura para compradores en más de 90 países con Credlix, hasta 120 días.',src:IMAGES.HomeNew.mxSolutionIcon1, color:'#FCE2E8', href: '/export-factoring/' },
        {heading:'Financiamiento de Canal',paragraph:'Empodera a tus clientes con capital instantáneo y sin garantías.',src:IMAGES.HomeNew.mxSolutionIcon2, color:'#DBFFF9', href: '/partner-program'},
        {heading:'Compradores Globales',paragraph:'Desbloquea soluciones de financiamiento flexible como comprador para mejorar la relación con tus proveedores.',src:IMAGES.HomeNew.mxSolutionIcon3, color:'#D5E8FF', href: '/global-buyer'},
    ]

},
SubSolutionsSec:{
  heading:'¿Por qué elegir Credlix?',
  para1:'Soluciones de Capital Personalizadas para Tu Empresa',
  para2:'Credlix automatiza el financiamiento, permitiéndote enfocarte en hacer crecer tu negocio.',
  para3:'¿Listo para llevar tu negocio al siguiente nivel?',
  para4:'Asegura el financiamiento para tu empresa.',
  // src: IMAGES.HomeNew.termsheetClock,
  ctaHref:null,
  ctaText:'Obtén financiamiento ahora',
  FooterIndiaForm:false,
  subSolutions:[
    {heading:null, src:IMAGES.HomeNew.subSol1,para:"Financiamiento de hasta <strong>$5 millones</strong> disponible en <strong>48 horas</strong>."},
    {heading:null, src:IMAGES.HomeNew.subSol2,para:"Se requiere garantía <strong>cero</strong>."},
    {heading:null, src:IMAGES.HomeNew.subSol3,para:"Hasta el <strong>90% del valor de la factura</strong> en capital de trabajo."},
    {heading:null, src:IMAGES.HomeNew.subSol4,para:"Gestiona múltiples <strong>líneas de crédito</strong> de manera fluida."},
    {heading:null, src:IMAGES.HomeNew.subSol5,para:"Proceso sin complicaciones, <strong>seguro y confiable</strong>."},
  ]

},
ConuterSec:{
  heading:'De Raíces Locales a Expansión Global',
  paragraph:'Credlix Impulsa el Crecimiento de las PYMES',
  bannerImg : IMAGES.HomeNew.numbersBg,
  bannerMbImage:null,
  counterList:[
      {heading:'7500', paragraph:'Facturas Financiadas', smalltext:'+'},
      {heading:'5000', paragraph:'PYMES Registradas', smalltext:'+'},
      {heading:'$1', paragraph:'Financiación de exportaciones', smalltext:'Bn+'},
      {heading:'120', paragraph:'Cobertura Ciudades', smalltext:'+'}
  ]
},
CapitalSolution:false,
CapitalSolutionSec:null,
BookAMeeting:'Book a Meeting Now',
HowItWorks:{
  heading:'Cómo Funciona',
  steps:[
    {id:'1', name:'El Exportador Envía los Bienes', para:'Registra a tus compradores en Credlix y accede a su información crediticia en minutos.'},
    {id:'2', name:'El Comprador Recibe los Bienes', para:'Coordina la entrega con tu comprador y designa a Credlix como tu socio de factoraje.'},
    {id:'3', name:'Credlix Financia', para:'Recibe un anticipo de hasta el 90% del valor de la factura después de verificar la entrega de los bienes.'},
  ]
},
Investers:{
  heading:'Contamos con el respaldo de inversores globales.',
  investerslList:[
      {src:IMAGES.HomeNew.sequoiaNew, alt:'Sequoia'},
      {src:IMAGES.HomeNew.accelNew, alt:'accel'},
      {src:IMAGES.HomeNew.falconNew, alt:'falcon'},
      {src:IMAGES.HomeNew.havardNew, alt:'havard'},
      {src:IMAGES.HomeNew.tigerNew, alt:'tiger'},
      {src:IMAGES.HomeNew.jungleNew, alt:'jungle'},
      {src:IMAGES.HomeNew.falconEdge, alt:'falcon Edge'},
      {src:IMAGES.HomeNew.tigerGlobal, alt:'Tiger Global'},
      {src:IMAGES.HomeNew.seedPlus, alt:'Seed Plus'},
      {src:IMAGES.HomeNew.compositeCapital, alt:'Composite Capital'},
      {src:IMAGES.HomeNew.infinanceCorp, alt:'IFC'},
      
  ],
},
GlobalNetwork:{
heading:'Nuestra <strong>Red Global</strong> <br/>Permite resultados más rápidos',
para:'Con oficinas en India, EE. UU., EAU y México, Credlix ofrece soporte y experiencia a clientes en todo el mundo.',
flags:[
  {flag:IMAGES.HomeNew.indiaFlag,name:'India'},
  {flag:IMAGES.HomeNew.mexicoFlag,name:'Mexico'},
  {flag:IMAGES.HomeNew.singaporeFlag,name:'Singapore'},
  {flag:IMAGES.HomeNew.usaFlag,name:'USA'},
  {flag:IMAGES.HomeNew.uaeFlag,name:'UAE'},
]
},
WhyChooseCredlix:false,
Credibility:{
  heading:'Credibilidad en la que Puedes Confiar',
  subHeading:'Respaldado por el reconocimiento de la industria.',
  awards:[
      IMAGES.HomeNew.award1,IMAGES.HomeNew.award2,IMAGES.HomeNew.award3,IMAGES.HomeNew.award4,IMAGES.HomeNew.award5,IMAGES.HomeNew.award6,
      IMAGES.HomeNew.award7,IMAGES.HomeNew.award8,IMAGES.HomeNew.award9,IMAGES.HomeNew.award10,IMAGES.HomeNew.award11,IMAGES.HomeNew.award12
    ],
},
Testimonial:true,
Customers:{
    heading:'Testimonios de Clientes',
    paragraph: '',
    knowMoreCta: '',
    customersList:[
        {CustomerQuote:'Usar los servicios de factorage de Credlix, le ha dado estabilidad y flujo de efectivo a mi empresa, el proceso fluye tan fácil que en un par de minutos se procesan las facturas correspondientes y en un par de horas ya tienes el dinero en tu banco.',  CustomerDesignation:'Exportador de PyMEs de Mexicali – Sector Aeroespacial y de Defensa '},
        {CustomerQuote:'Los plazos largos de pago en las exportaciones siempre afectaban nuestro flujo de efectivo. Ahora, con el financiamiento rápido de Credlix, podemos operar con mayor estabilidad y aprovechar mejor la temporada alta.', CustomerDesignation:'Exportador de PyMes de Mexicali - Sector Agrícola y Agroindustrial '},
        {CustomerQuote:'Credlix nos ha ayudado a mantenernos competitivos en el mercado. Como fabricante de productos, trabajamos con pedidos grandes y pagos diferidos. Gracias al financiamiento oportuno de Credlix, podemos mantener nuestra producción sin interrupciones por falta de liquidez. ',CustomerDesignation:'Exportador de PyMes de Mexicali - Industria del Empaque y la Logística '},
        {CustomerQuote:'Gracias a Credlix, hemos podido enfocarnos plenamente en nuestro crecimiento y en alcanzar nuestras metas. El financiamiento recibido nos ha brindado la capacidad de implementar nuevas estrategias en el sector de frutas, además de agilizar la distribución de nuestros productos para los mercados de exportación.',CustomerDesignation:'Exportador de PyMes de Mexicali - Sector Agrícola y Agroindustrial '},    
      ]
  },
  
DownloadApp:false,
blogShow:false,
FAQ:{
  Faq_heading:'Preguntas frecuentes',
  Home_Faq:[
      {   id:0,
        Q:"¿Qué es la financiación de la cadena de suministro?",
        A:"Cualquier entidad es elegible para aprovechar la financiación de la cadena de suministro. Las empresas unipersonales y asociadas también pueden utilizar este servicio. La financiación de la cadena de suministro es como una ayuda de alta tecnología para las empresas que hace que los acuerdos sean más fluidos, sin complicaciones y más rentables. Es un conjunto de procesos inteligentes que utilizan la tecnología para reducir los gastos y hacer que las cosas funcionen mejor para todos en un acuerdo comercial. Es como una herramienta que ayuda a los compradores y vendedores en una transacción a ahorrar dinero y hacer las cosas más rápido."
      },
      {   id:1,
        Q:"¿Cuáles son los documentos necesarios para la financiación de la cadena de suministro?",
        A:"Los documentos necesarios para la financiación de la cadena de suministro son los siguientes:",
        list:["prueba de identidad","Verificación de domicilio","Documentos financieros","Documentos de propiedad empresarial."]
      },
      {   id:2,
        Q:"¿Cuáles son los tipos de servicios comerciales que se ofrecen en Supply Chain Finance?",
        A:"Los tipos de servicios comerciales ofrecidos en Supply Chain Finance son los siguientes:",
        list:["Descuento de facturas","Descuento dinámico","Plataformas de financiación de la cadena de suministro","Finanzas de cuentas por cobrar","Financiamiento de cuentas por pagar","Financiamiento de inventario","Financiamiento de órdenes de compra","Financiamiento del canal"]
      },
      {   id:3,
        Q:"¿Cuáles son los criterios de elegibilidad para el financiamiento de la cadena de suministro?",
        A:"Para poder aprovechar la financiación de la cadena de suministro, los criterios de elegibilidad son los siguientes:",
        list:["Solvencia","Nacionalidad india","Antigüedad empresarial de al menos 3 años.","Volumen de transacciones","Relación comercial","Facturas y cuentas por cobrar","Visibilidad de la cadena de suministro","Cumplimiento","Salud financiera","Una buena puntuación CIBIL"]
      },
      {   id:4,
        Q:"¿Cuáles son las tasas de interés para el financiamiento de la cadena de suministro?",
        A:"No existe una tasa de interés fija para las finanzas de la cadena de suministro. Depende de varios factores como el proveedor, la confiabilidad de la empresa, la solvencia crediticia, las condiciones del mercado y más. La tasa de interés es principalmente de naturaleza competitiva."
      },
      {   id:5,
        Q:"¿Cómo se puede solicitar financiación de la cadena de suministro?",
        A:"",
        list:["Paso 1: Inicie sesión en nuestro sitio web https://www.credlix.com/","Paso 2: proporcione toda la información necesaria.","Paso 3: revise detenidamente los criterios de elegibilidad.","Paso 4: Acordar los términos de financiamiento con Credlix.","Paso 5: La aprobación final."]
      },
      {   id:6,
        Q:"¿Cuáles son las características y beneficios del financiamiento de la cadena de suministro?",
        A:"Características y beneficios de la financiación de la cadena de suministro:",
        list:["Buen capital de trabajo y flujo de caja.","Mejor gestión de inventario. ","Buenos rendimientos","Bajo costo","Proceso digital, rápido y seguro","Hasta el 90% de las facturas financiadas","No se requiere garantía"]
      },
        {   id:7,
            Q:"¿Quiénes pueden aprovechar la financiación de la cadena de suministro?",
            A:"Cualquier entidad es elegible para aprovechar la financiación de la cadena de suministro. Las empresas unipersonales y asociadas también pueden utilizar este servicio."
          },
          {
            id:8,
            Q:"¿Cuál es el plazo de reembolso del financiamiento de la cadena de suministro? ",
            A:"El plazo de amortización de la financiación de la cadena de suministro es de 12 meses. Según los requisitos comerciales, también se puede ampliar."
          },
          {
            id:9,
            Q:"¿Cuáles son los tipos de préstamos para pymes para la financiación de la cadena de suministro? ",
            A:"Los cuatro tipos comunes de préstamos para PYMES para la financiación de la cadena de suministro son la financiación de facturas, la financiación de órdenes de compra, la financiación de la cadena de suministro y la financiación de inventarios."
          },
          {
            id:10,
            Q:"¿Cómo calcula y finaliza la tasa de interés la empresa que proporciona financiación de la cadena de suministro?",
            A:"La compañía financiera de la cadena de suministro calcula la tasa de interés en función de cuánto del límite de crédito ha utilizado el cliente."
          },
          {
            id:11,
            Q:"¿Cuántos límites puede aprovechar una empresa en la financiación de la cadena de suministro? ",
            A:"Una empresa puede recibir hasta entre el 80% y el 85% del valor total de la factura. También depende de los requisitos específicos y los criterios de elegibilidad establecidos por la empresa financiera de la cadena de suministro."
          }
    ],
},
   
    
}